






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component({
  name: 'chart',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) icon: string
  @Prop({ required: true }) name: string
  @Prop({ required: true }) value: string
}
